<h3 class="text-sm font-semibold text-foreground">Pricing calculation</h3>

@let summary = calculation();

<div class="flex items-start justify-between gap-4">
    <div>
        <p class="mt-2 text-xs font-semibold text-foreground">
            Selected band ({{ summary.metricLabel }} method)
        </p>
        <p class="text-xs text-muted">
            {{ summary.rangeLabel }}
        </p>
    </div>
    <div class="text-right">
        <p class="text-xs font-semibold text-foreground">&nbsp;</p>
        <p class="mt-2 text-xs font-semibold text-foreground">
            Annual band amount
        </p>
        <p class="text-xs text-muted">
            {{ summary.amountLabel }}
        </p>
    </div>
</div>

<div class="mt-3 h-2 overflow-hidden rounded-full bg-muted">
    <div
        class="h-full rounded-full bg-primary"
        [style.width.%]="summary.currentPositionPercent"
    ></div>
</div>
<div class="mt-2 grid grid-cols-3 text-xs font-semibold text-muted">
    <span>{{ summary.minLabel }} {{ summary.metricUnit }}</span>
    <span class="text-center font-semibold text-foreground">
        {{ summary.currentLabel }} {{ summary.metricUnit }} selected
    </span>
    <span class="text-right"
        >{{ summary.maxLabel }} {{ summary.metricUnit }}</span
    >
</div>
